import { gpHome } from '../../app';
import { IUibModalInstance, ModalService } from '../../../app-common/services/bootstrap-ui-modal';
import gpLicenceOptionsDialogTemplate from './gp-licence-options-dialog.html';
import { AccountRefreshAllEvent } from '../../services/account-refresh-contract';

declare var htmx: any;

/**
 * The tier list, in a dialog. It used to swap into the account card itself,
 * where three tier cards do not fit. The markup is the web role's own —
 * /user-setup/subscription-options, the same list first-run renders — so the
 * dialog supplies only the room and the fetch.
 */
interface gpLicenceOptionsDialogScope extends ng.IScope {
    close(): void;
}

export const LicenceOptionsBodyId = 'gp-licence-options-body';

/**
 * What the web role's no-payment route answers the account screen with, as an
 * HX-Trigger, instead of the redirect first-run gets (UserSetupController
 * .LicenceChosenEvent). The licence is minted; the dialog's job is done.
 */
export const LicenceChosenEvent = 'gp-licence-chosen';

gpHome.controller('gpLicenceOptionsDialog', ['$scope', '$uibModalInstance', '$timeout', '$rootScope',
    function (
        $scope: gpLicenceOptionsDialogScope,
        $uibModalInstance: IUibModalInstance<void>,
        $timeout: ng.ITimeoutService,
        $rootScope: ng.IRootScopeService,
    ) {
        $scope.close = () => $uibModalInstance.dismiss('close');

        // htmx raises the trigger on the Select button, inside this dialog, and it
        // bubbles to the document. Close, then refresh the account panels in place
        // — the page underneath is the one that should now show the licence.
        // Wrapped in $apply because the event arrives from outside Angular.
        const onChosen = () => {
            $rootScope.$apply(() => {
                $uibModalInstance.close(undefined);
                $rootScope.$broadcast(AccountRefreshAllEvent);
            });
        };
        document.addEventListener(LicenceChosenEvent, onChosen);
        $scope.$on('$destroy', () => document.removeEventListener(LicenceChosenEvent, onChosen));

        // Once the template is in the DOM. htmx processes only content it swapped
        // in itself, so the first fetch is made by hand. innerHTML rather than
        // outerHTML: the closed-options panel and the payment step both land in
        // this same container, and Subscribe buttons inside it keep working
        // because htmx does process what it swaps.
        $timeout(() => {
            htmx.ajax('POST', '/user-setup/subscription-options', {
                target: '#' + LicenceOptionsBodyId,
                swap: 'innerHTML',
            });
        }, 0);
    }]);

export class LicenceOptionsDialogService {
    /**
     * Injected by this constant, not a string, so the importing module uses the
     * class as a VALUE. A type-only import is elided from the bundle, and with it
     * the registration below — the whole account page then failed to instantiate
     * with $injector:unpr, which no static check caught.
     */
    static readonly serviceName = 'gpLicenceOptionsDialogService';
    static $inject = ['gpModal'];

    constructor(private readonly modalService: ModalService) {
    }

    show(): ng.IPromise<void> {
        return this.modalService.open<void>({
            animation: true,
            template: gpLicenceOptionsDialogTemplate,
            controller: 'gpLicenceOptionsDialog',
            backdrop: true,
            windowClass: 'gameplan-gp-licence-options-dialog',
        }).result;
    }
}

gpHome.service(LicenceOptionsDialogService.serviceName, LicenceOptionsDialogService);
